const ionic = {
  alert: document.querySelector("ion-alert-controller"),
  actionSheet: document.querySelector("ion-action-sheet-controller"),
  loading: document.querySelector("ion-loading-controller"),
  toast: document.querySelector("ion-toast-controller"),
  popover: document.querySelector("ion-popover-controller"),
  _indicator: null,
  _popup: null
};

ionic.showAlert = async function(message, options = {}) {
  await ionic.alert.componentOnReady();
  const alert = await ionic.alert.create({
    header: options.header,
    cssClass: options.cssClass || "medium-width-alert",
    subHeader: options.subHeader,
    message: message,
    buttons: options.buttons,
    inputs: options.inputs
  });
  return alert.present();
};

ionic.showToast = async function(message, options = {}) {
  await ionic.toast.componentOnReady();
  const conf = {
    message: message,
    showCloseButton: options.showCloseButton || true,
    closeButtonText: options.closeButtonText || "Dismiss",
    position: options.position,
    duration: options.duration || 2500
  };

  let toast = await ionic.toast.create(conf);
  return toast.present();
};

ionic.showLoading = async function(message, options = {}) {
  await ionic.loading.componentOnReady();

  const ionLoading = document.getElementsByTagName("ion-loading")[0];

  let timeOut = 10;
  if (ionLoading) {
    ionLoading.dismiss();
    timeOut = 200;
  }

  ionic._indicator = await ionic.loading.create({
    message: message,
    spinner: options.spinner,
    duration: options.duration
  });

  return setTimeout(()=>{
    return ionic._indicator.present();
  }, timeOut);
};

ionic.dismissLoading = async function() {
  const ionLoading = document.getElementsByTagName("ion-loading")[0];
  if (ionLoading) {
    ionLoading.dismiss();
  }
};

ionic.showPopover = async function(evt, options = {}) {
  await ionic.popover.componentOnReady();
  const popover = await ionic.popover.create({
    cssClass: options.cssClass || "",
    component: "ion-popover-component",
    componentProps: options,
    event: evt,
    showBackdrop: true
  });
  ionic._popup = popover;
  await popover.present();
  return popover;
};

ionic.dismissPopover = function() {
  if (ionic._popup) {
    ionic._popup.dismiss();
    ionic._popup = null;
  } else {
    const ionPopover= document.getElementsByTagName("ion-popover");
    for( let i of ionPopover) {
      i.dismiss();
    }
  }
};

class PopoverComponent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {

    if (this.hasAttribute('popover')) {
      this.removeAttribute('popover');
    }
    // this is a little hacky
    window.$pp = this;
    const shadowRoot = this; // this.attachShadow({mode: 'open'});
    const c = document.querySelector(`#${this.template}`);
    shadowRoot.appendChild(c.firstElementChild);
  }
}

window.customElements.define("ion-popover-component", PopoverComponent);

ionic.mixins = {
  methods: {
    async toast(message, options) {
      await this.$ionic.toast.componentOnReady();
      this.$ionic.toast
        .create({
          message: message,
          position: options.position || "top",
          duration: options.duration || 2000,
          showCloseButton: options.showCloseButton !== undefined,
          closeButtonText: options.closeButtonText || "Done"
        })
        .then(a => {
          a.present();
        });
    }
  }
};

export default ionic;
